export const djangoRedirectorPath = '/welcome/';
